import { render, staticRenderFns } from "./ConfirmPhoneChangeModal.vue?vue&type=template&id=65276552&scoped=true&"
import script from "./ConfirmPhoneChangeModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPhoneChangeModal.vue?vue&type=style&index=0&id=65276552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65276552",
  null
  
)

export default component.exports